import React from 'react';
import ReactNativeHapticFeedback, {
  HapticFeedbackTypes,
} from 'react-native-haptic-feedback';

import BottomSheet from '../../../../components/Interface/BottomSheet';

import {
  FilterActiveBadge,
  FilterActiveBadgeText,
  FilterApplyBtn,
  FilterApplyBtnText,
  FilterCategoryChip,
  FilterCategoryIcon,
  FilterCategoryText,
  FilterChip,
  FilterChipIcon,
  FilterChipText,
  FilterChipsRow,
  FilterClearBtn,
  FilterClearBtnText,
  FilterContent,
  FilterDivider,
  FilterFooter,
  FilterHeaderRow,
  FilterSection,
  FilterSectionTitle,
  FilterSheetTitle,
} from './styles';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  uniqueNames: string[];
  uniqueCategories: string[];
  selectedNames: string[];
  selectedCategories: string[];
  onToggleName: (name: string) => void;
  onToggleCategory: (cat: string) => void;
  onClear: () => void;
}

export function CouponFilterSheet({
  isOpen,
  onClose,
  uniqueNames,
  uniqueCategories,
  selectedNames,
  selectedCategories,
  onToggleName,
  onToggleCategory,
  onClear,
}: Props) {
  const activeCount = selectedNames.length + selectedCategories.length;
  const hasActive = activeCount > 0;

  const triggerHaptic = () =>
    ReactNativeHapticFeedback.trigger(HapticFeedbackTypes.impactLight, {
      enableVibrateFallback: false,
    });

 function transformCategoryLabel(cat: string) {
  if(cat === 'ouro') {return 'Super Barato';}
  if(cat === 'prata') {return 'Barato';}
  return cat;
 }

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <FilterContent>
        <FilterHeaderRow>
          <FilterSheetTitle>Filtrar Cupons</FilterSheetTitle>
          {hasActive && (
            <FilterActiveBadge>
              <FilterActiveBadgeText>
                {activeCount} ativo{activeCount > 1 ? 's' : ''}
              </FilterActiveBadgeText>
            </FilterActiveBadge>
          )}
        </FilterHeaderRow>

        {uniqueNames.length > 0 && (
          <FilterSection>
            <FilterSectionTitle>Tipo de Produto</FilterSectionTitle>
            <FilterChipsRow>
              {uniqueNames.map(name => {
                const active = selectedNames.includes(name);
                return (
                  <FilterChip
                    key={name}
                    active={active}
                    activeOpacity={0.75}
                    onPress={() => {
                      triggerHaptic();
                      onToggleName(name);
                    }}>
                    <FilterChipIcon name="gas-station" active={active} />
                    <FilterChipText active={active}>{name}</FilterChipText>
                  </FilterChip>
                );
              })}
            </FilterChipsRow>
          </FilterSection>
        )}

        {uniqueCategories.length > 0 && (
          <>
            <FilterDivider />
            <FilterSection>
              <FilterSectionTitle>Categoria</FilterSectionTitle>
              <FilterChipsRow>
                {uniqueCategories.map(cat => {
                  const active = selectedCategories.includes(cat);
                  const isGold = cat.toLowerCase() === 'ouro';

                  return (
                    <FilterCategoryChip
                      key={cat}
                      active={active}
                      isGold={isGold}
                      activeOpacity={0.75}
                      onPress={() => {
                        triggerHaptic();
                        onToggleCategory(cat);
                      }}>
                      <FilterCategoryIcon
                        name={'medal'}
                        active={active}
                        isGold={isGold}
                      />
                      <FilterCategoryText active={active} isGold={isGold}>
                        {transformCategoryLabel(cat)}
                      </FilterCategoryText>
                    </FilterCategoryChip>
                  );
                })}
              </FilterChipsRow>
            </FilterSection>
          </>
        )}

        <FilterFooter>
          <FilterClearBtn activeOpacity={0.75} onPress={onClear}>
            <FilterClearBtnText>Limpar</FilterClearBtnText>
          </FilterClearBtn>
          <FilterApplyBtn activeOpacity={0.85} onPress={onClose}>
            <FilterApplyBtnText>Aplicar</FilterApplyBtnText>
          </FilterApplyBtn>
        </FilterFooter>
      </FilterContent>
    </BottomSheet>
  );
}
